function useStyles() {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: 1.5,
      margin: '20px 0',
      padding: '0 8px',
      flex: 1,
      width: '100%',
      overflowY: 'auto',
      minHeight: 0,
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': { display: 'none' },
    },
    scrollableSection: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  }
}

export { useStyles }
